<template>
  <div class="appointmentManagement-view">
    <el-tabs class="tabs" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="$t('merchandise', 'appointmentList')" name="first"
        ><appointmentList v-if="activeName == 'first'" :jurisdiction="jurisdiction"
      /></el-tab-pane>
      <el-tab-pane :label="$t('merchandise', 'appointmentGoodsList')" name="second"
        ><appointmentGoodsList
          v-if="activeName == 'second'"
          :jurisdiction="jurisdiction"
        ></appointmentGoodsList
      ></el-tab-pane>
      <el-tab-pane :label="$t('merchandise', 'appointmentClassifyList')" name="third"
        ><classifyList v-if="activeName == 'third'" :jurisdiction="jurisdiction"></classifyList
      ></el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import appointmentList from "./appointment/appointmentList";
import appointmentGoodsList from "./appointment/appointmentGoodsList";
import classifyList from "./appointment/classifyList";
import { mapState } from 'vuex';
import i18nMixin from '@/mixins/i18nMixin';

export default {
  mixins: [i18nMixin],
  name: "appointmentManagement",
  components: {
    appointmentList,
    appointmentGoodsList,
    classifyList,
  },
  data() {
    return {
      activeName: "first",
      jurisdiction:false,
    };
  },
  computed: {
    ...mapState(['routerArr']),
  },
  watch:{
    routerArr(val){
      this.jurisdiction = val.includes("041")
    },
  },
  mounted() {
    // 监听语言变化，强制更新组件
    this.$root.$on('language-changed', () => {
      this.$forceUpdate();
    });
  },
  beforeDestroy() {
    // 清理事件监听
    this.$root.$off('language-changed');
  },
  methods: {
    handleClick(tab) {
      const { name } = tab;
      this.activeName = name;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>